import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Input } from '@hotjar/webapp/components/Input';
import { Select } from '@hotjar/webapp/components/Select';
import { Icon } from '@hotjar/webapp/components/Icon';
import { tokens } from '@hotjar/hotsauce';
import { Checkbox } from '@hotjar/webapp/components/Checkbox';
import { ErrorMessage } from '@hotjar/webapp/components/Message';

export const PageTitle = styled.div`
  ${tokens.text('header4')};
  margin: 0 0 ${tokens.spacer.x1} 0;
`;

export const PageSubTitle = styled.div`
  ${tokens.text('body1')};
  color: ${tokens.color.text_light};
  margin: 0 0 ${tokens.spacer.x1} 0;
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${tokens.color.text_default};
  display: block;
  margin: 0 0 ${tokens.spacer.x1} 0;
`;

export const StyledInput = styled(Input)`
  font-weight: normal;
  text-transform: none;
`;

export const errorMessageStyles = css`
  color: ${tokens.color.text_danger};
  margin-top: 4px;
  font-size: 12px;
`;

export const StyledSelect = styled(Select)`
  font-weight: normal;
  text-transform: none;
`;

export const TitleSection = styled.div`
  margin: 0 0 ${tokens.spacer.x6} 0;
`;

export const FormRow = styled.div`
  margin: 0 0 ${tokens.spacer.x3} 0;
`;

export const ButtonRow = styled.div`
  margin: ${tokens.spacer.x6} 0;
`;

export const ReadOnlyData = styled.div`
  color: ${tokens.color.text_success};
`;

export const ReadOnlyDataIcon = styled(Icon)`
  margin: 0 ${tokens.spacer.x0} 0 0;
`;

export const StyledCheckbox = styled(Checkbox)`
  label a {
    color: ${tokens.color.text_light};
  }
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  margin: 0 0 ${tokens.spacer.x6} 0;
`;
